import { footerColumns } from '@/mocks/home';

const socialLinks = [
  { icon: 'ri-wechat-line', label: '微信' },
  { icon: 'ri-weibo-line', label: '微博' },
  { icon: 'ri-mail-line', label: '邮件' },
  { icon: 'ri-rss-line', label: '订阅' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-4 lg:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="font-display text-4xl leading-none text-accent-400">17</span>
              <span className="font-heading text-lg font-bold text-background-50">17黑料网</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-7 text-background-200">
              一份围绕 17黑料网 的公开档案，收录黑历史、翻车合集、塌房记录、负面新闻与争议事件，
              并按热度整理出长期的槽点汇总。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {socialLinks.map((item) => (
                <a
                  key={item.label}
                  href="#top"
                  aria-label={item.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-background-50/20 text-background-100 transition-colors hover:border-accent-400 hover:text-accent-400 cursor-pointer"
                >
                  <i className={`${item.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <p className="font-heading text-sm font-bold tracking-wide text-background-50">
                {column.title}
              </p>
              <ul className="mt-5 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-200 transition-colors hover:text-accent-400 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-background-50/15 pt-8">
          <p className="text-xs leading-6 text-background-200/80">
            本站内容为公开信息的整理与归类，用于帮助读者快速了解 17黑料网 相关的黑历史、翻车合集、
            塌房记录、负面新闻、争议事件与槽点汇总，不构成任何形式的定论或指控。
          </p>
          <div className="mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-background-200/70">
              © 2025 17黑料网 · 档案整理计划
            </p>
            <div className="flex flex-wrap items-center gap-6">
              <a href="#tags" className="text-xs text-background-200/70 transition-colors hover:text-accent-400 cursor-pointer">
                整理原则
              </a>
              <a href="#press" className="text-xs text-background-200/70 transition-colors hover:text-accent-400 cursor-pointer">
                来源标注
              </a>
              <a href="#top" className="text-xs text-background-200/70 transition-colors hover:text-accent-400 cursor-pointer">
                回到顶部
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}